var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 37,
    viewBox: "0 0 38 37",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0.977539 3.37683C0.977539 1.62512 2.39758 0.205078 4.14928 0.205078H33.9637C35.7154 0.205078 37.1354 1.62512 37.1354 3.37682V33.1912C37.1354 34.9429 35.7154 36.363 33.9637 36.363H4.14929C2.39758 36.363 0.977539 34.9429 0.977539 33.1912V3.37683Z",
    fill: "url(#paint0_linear_427_26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.9792 8.89504C17.8089 7.45801 19.8831 7.45801 20.7127 8.89504L30.7133 26.2165C31.5429 27.6535 30.5059 29.4498 28.8465 29.4498H8.84545C7.1861 29.4498 6.14901 27.6535 6.97869 26.2165L16.9792 8.89504Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.8999 24.0439C18.1371 24.0439 17.4977 24.6832 17.4977 25.446C17.4977 26.2088 18.1371 26.8481 18.8999 26.8481C19.6346 26.8481 20.302 26.2088 20.2684 25.4796C20.302 24.6776 19.6682 24.0439 18.8999 24.0439Z",
    fill: "url(#paint1_linear_427_26)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18.5529 14.2002C17.8855 14.3909 17.4705 14.9966 17.4705 15.7314C17.5041 16.1744 17.5322 16.6231 17.5658 17.0662C17.6612 18.7544 17.7565 20.4089 17.8519 22.0971C17.8855 22.6691 18.3286 23.0842 18.9007 23.0842C19.4727 23.0842 19.9214 22.6411 19.9495 22.0634C19.9495 21.7157 19.9495 21.396 19.9831 21.0426C20.0448 19.9602 20.1121 18.8778 20.1738 17.7953C20.2075 17.0942 20.2691 16.3932 20.3028 15.6921C20.3028 15.4397 20.2691 15.2154 20.1738 14.991C19.8878 14.3629 19.2203 14.0432 18.5529 14.2002Z",
    fill: "url(#paint2_linear_427_26)"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_427_26",
    x1: 17.4702,
    y1: 18.6229,
    x2: 20.3025,
    y2: 18.6229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_427_26",
    x1: 17.4702,
    y1: 18.6229,
    x2: 20.3025,
    y2: 18.6229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8500"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_427_26",
    x1: 17.4702,
    y1: 18.6229,
    x2: 20.3025,
    y2: 18.6229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FCA017"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE8500"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoIcon);
export default __webpack_public_path__ + "static/media/info_icon.91fd9c4216260544297679c53b01af24.svg";
export { ForwardRef as ReactComponent };